module.exports = __webpack_public_path__ + "img/colored-rounded.f6dbfe6a.svg";